<template>
    <v-autocomplete
        v-model="setup.selectedItems"
        :items="setup.items"
        :filter="customFilter"
        :label="setup.label"
        :item-text="setup.text"
        :item-value="setup.value"
        :prepend-icon="setup.icon"
        :rules="setup.rule"
        :required="setup.required"
        :readonly="setup.readonly"
        :no-data-text="$t('common.noDataText')"
        dense
        :multiple="setup.multiple"
        :filled="setup.filled"
        :clearable="setup.clearable"
        :hide-details="(setup.hideDetails !== undefined && setup.hideDetails === true)"
    >
        <template v-slot:prepend-item v-if="setup.multiple">
            <v-list-item
                ripple
                @click="toggleSelectItem(setup)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ selectAction(setup) }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>

        <template
            slot="selection"
            slot-scope="{ item, index }"
        >
            <span v-if="index === 0" id="value-text">{{ truncateText($helpers.getObjectValueByPath(item, setup.text)) }}</span>
            <span
                v-if="index === 1"
                class="grey--text caption"
                id="value-other"
            >(+{{ setup.selectedItems.length - 1 }} outros)</span>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'input-auto-complete',
    props: ['setup'],
    data () { return {} },
    methods: {
        customFilter (item, queryText) {
            const name = item.name ?? item.nameLowerCase
            const textOne = name.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
        },
        selectAction: function (vm) {
            return (vm.selectedItems.length !== vm.items.length) ? this.$t('common.checkAll') : this.$t('common.uncheckAll')
        },
        toggleSelectItem (select) {
            this.$nextTick(() => {
                if (select.selectedItems.length === select.items.length) {
                    select.selectedItems = []
                } else {
                    select.items.forEach((item) => {
                        if (select.selectedItems.indexOf(item[this.setup.value]) === -1) {
                            select.selectedItems.push(item[this.setup.value])
                        }
                    })
                }
            })
        },
        truncateText (text) {
            const rootElement = document.getElementById('value-text')
            const siblingElement = document.getElementById('value-other')

            if (!rootElement) return text

            const measuringElement = document.createElement('span')
            let maxWidth = rootElement.parentElement.offsetWidth
            let diff = text.length

            if (siblingElement !== null) {
                maxWidth -= siblingElement.innerText.length
                diff += (text.length + siblingElement.innerText.length)
            }

            measuringElement.style.visibility = 'hidden'
            measuringElement.style.whiteSpace = 'nowrap'
            measuringElement.style.position = 'absolute'
            measuringElement.style.width = 'auto'
            measuringElement.style.padding = '0'
            measuringElement.style.margin = '0'
            measuringElement.style.fontSize = 'inherit'
            measuringElement.style.fontFamily = 'inherit'
            document.body.appendChild(measuringElement)
            let truncatedText = text
            measuringElement.innerText = truncatedText
            if (measuringElement.offsetWidth > maxWidth) {
                for (let i = text.length; i > 0; i--) {
                    truncatedText = text.substring(0, i) + '...'
                    measuringElement.innerText = truncatedText

                    if (measuringElement.offsetWidth < (maxWidth - diff)) {
                        break
                    }
                }
            }
            document.body.removeChild(measuringElement)
            return truncatedText
        }
    }
}
</script>
